import { render } from "./picbook.vue?vue&type=template&id=81335d40&scoped=true"
import script from "./picbook.vue?vue&type=script&lang=js"
export * from "./picbook.vue?vue&type=script&lang=js"

import "./picbook.vue?vue&type=style&index=0&id=81335d40&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mguoxueweb_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81335d40"]])

export default __exports__